// extracted by mini-css-extract-plugin
export var container = "_4u-0";
export var icon = "_4u-1";
export var text = "_4u-2";